export default class Settings {
  constructor() {}
  data = Set();
  dumpSettings() {
    return this.data;
  }
  getSetting(name) {
    return this.data[name];
  }
}



// WEBPACK FOOTER //
// ./src/settings.js